import React, { useState } from 'react';
import { Navigation } from './components/training/Navigation.tsx';
import { HomePage } from './pages/HomePage.tsx';
import { TrainingPage } from './pages/TrainingPage.tsx';
import { ServicesPage } from './pages/ServicesPage.tsx';
import {ContactPage} from './pages/ContactPage.tsx';
import './App.css';

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');

  return (
    <div className="app">
      <Navigation currentPage={currentPage} onNavigate={setCurrentPage} />
      {currentPage === 'home' && <HomePage />}
      {currentPage === 'training' && <TrainingPage />}
      {currentPage === 'services' && <ServicesPage />}
      {currentPage === 'contact' && <ContactPage />}
    </div>
  );
}
